<script setup>
import { computed, defineProps } from 'vue'

const props = defineProps({
  card: {
    type: Object,
    required: true,
  },
})

const settings = computed(() => props.card?.settings ?? {})

const rootClasses = computed(() => {
  const cls = ['content-item']

  if (settings.value.hideForABTest) cls.push('-hide-ab-test')
  if (settings.value.hideMobile) cls.push('-hide-mobile')
  if (settings.value.hideTablet) cls.push('-hide-tablet')
  if (settings.value.hideDesktop) cls.push('-hide-desktop')

  return cls.join(' ')
})

</script>

<template>
  <div
    :class="rootClasses"
    :id="settings.anchor || null"
  >
    <div v-html="card.bodytext"></div>
  </div>
</template>
